import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LoginPage from './LoginPage';
import {
    clearAuthNotification as clearAuthNotificationAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
} from '../../actions/auth';
import { onSkipSocialLinks } from '../../actions/mocks';
import { socialLogInUser as socialLogInUserAction } from '../../actions/social';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
});
const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onSkipSocialLinks,
    onSocialProviderClick: trackSocialProviderClickAction,
    onSocialLogInUser: socialLogInUserAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LoginPage),
);
